import request from '@/utils/request'

//获取课程老师列表
export function getcourseteacherlist(params) {
  return request({
    url: '/portal/course-teacher/get-list',
    method: 'GET',
    params
  })
}